module.exports = __webpack_public_path__ + "img/BG_inicio.8f83adc4.png";